import Chart from "react-apexcharts";
import { colors } from "../../global";

const TotalEnquiries = ({ data }) => {
  const chartData = {
    categories: data.map((item) => item.month),
    series: [
      {
        name: "Tickets",
        data: data.map((item) => item.ticket_count),
      },
    ],
  };

  return (
    <>
      <h2 className="text-lg font-semibold mb-4">Total Enquiries</h2>
      <Chart
        options={{
          chart: { type: "line", toolbar: { show: false } },
          stroke: { curve: "smooth", width: 3 },
          xaxis: {
            categories: chartData.categories,
            labels: { style: { fontSize: "12px" } },
          },
          yaxis: {
            title: { text: "Count of Tickets" },
            labels: {
              formatter: (val) => Math.round(val),
            },
          },
          colors: [colors.primary],
          markers: { size: 4 },
          tooltip: {
            y: {
              formatter: (val) => `${val.toLocaleString()} tickets`, 
            },
          },
          dataLabels: {
            enabled: true, 
            formatter: (val) => Math.round(val).toLocaleString(), 
            offsetY: -10, 
            style: {
              fontSize: "12px",
              fontWeight: "bold",
              colors: [colors.primary],
            },
          },
        }}
        series={chartData.series}
        type="line"
        height={300}
      />
    </>
  );
};

export default TotalEnquiries;
